// @ts-check
import React from "react"
import VacationDayVariantChip from "../../../components/molecules/VacationDayVariantChip.molecule"
import {
  HOLIDAY_SCHEMAS,
  VACATION_DAY_TYPES,
  VACATION_DAYS_VARIANTS,
  VACATION_SCHEMAS,
} from "../../../consts/modules/vacations.consts"

/**
 * @param {Object} props
 * @param {Object} props.before
 * @param {number} props.before.accordedDays
 * @param {number} props.before.additionalDays
 * @param {number} props.before.bucketDays
 * @param {number} props.before.plusDays
 * @param {number} props.before.total
 * @param {Object} props.after
 * @param {number} props.after.accordedDays
 * @param {number} props.after.additionalDays
 * @param {number} props.after.bucketDays
 * @param {number} props.after.plusDays
 * @param {number} props.after.total
 * @param {"foreign"|"mexican"} props.holidaySchema
 * @param {Object} props.usedDays
 * @param {number} props.usedDays.bucketDays
 * @param {number} props.usedDays.plusDays
 * @param {number} props.usedDays.accordedDays
 * @param {number} props.usedDays.additionalDays
 */
const VacationRequestDifferenceDays = ({
  before,
  after,
  holidaySchema,
  usedDays,
}) => {
  const bucketsDayChanged = before.bucketDays !== after.bucketDays
  const plusDaysChanged = before.plusDays !== after.plusDays
  const accordedDaysChanged = before.accordedDays !== after.accordedDays
  const additionalDaysChanged = before.additionalDays !== after.additionalDays
  const isMxSchema =
    holidaySchema !== VACATION_SCHEMAS.INTERNATIONAL &&
    holidaySchema !== HOLIDAY_SCHEMAS.FOREIGN

  const shouldShowBucket = isMxSchema && usedDays.bucketDays > 0
  const shouldShowPlus = usedDays.plusDays > 0
  const shouldShowAccorded = usedDays.accordedDays > 0
  const shouldShowAdditional = usedDays.additionalDays > 0

  const calculateTotalForUsedTypes = (
    /** @type {{bucketDays: number, plusDays: number, accordedDays: number, additionalDays: number}} */ days
  ) => {
    let total = 0
    if (shouldShowBucket) total += days.bucketDays
    if (shouldShowPlus) total += days.plusDays
    if (shouldShowAccorded) total += days.accordedDays
    if (shouldShowAdditional) total += days.additionalDays
    return total
  }

  const beforeTotal = calculateTotalForUsedTypes(before)
  const afterTotal = calculateTotalForUsedTypes(after)

  return (
    <div className="vacation-request-difference-days-container w-full">
      <div className="hr mb-3 mt-2 w-full" />
      <div className="pt-0 p-2">
        <div className="flex gap-3">
          <div className="flex flex-column gap-3 flex-grow-1">
            <span className="label font-semibold font-cairo text-xl line-height-1">
              Antes
            </span>
            <div className="flex flex-column gap-1">
              <span className="small-label font-semibold text-base font-mulish line-height-3">
                Días disponibles
              </span>
              <div className="flex gap-2 align-items-center">
                <span className="value font-semibold font-cairo text-xl">
                  {beforeTotal}
                </span>
                {shouldShowBucket && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.BUCKET}
                    quantity={before.bucketDays}
                    showQuantity
                    className={bucketsDayChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowPlus && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.PLUS}
                    quantity={before.plusDays}
                    showQuantity
                    className={plusDaysChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowAccorded && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.ACCORDED}
                    quantity={before.accordedDays}
                    showQuantity
                    className={accordedDaysChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowAdditional && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.EXTRA}
                    quantity={before.additionalDays}
                    showQuantity
                    className={additionalDaysChanged ? "" : "opacity-60"}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="vr h-auto" />
          <div className="flex flex-column gap-3 flex-grow-1">
            <span className="label font-semibold font-cairo text-xl line-height-1">
              Después
            </span>
            <div className="flex flex-column gap-1">
              <span className="small-label font-semibold text-base font-mulish line-height-3">
                Días disponibles
              </span>
              <div className="flex gap-2 align-items-center">
                <span className="value font-semibold font-cairo text-xl">
                  {afterTotal}
                </span>
                {shouldShowBucket && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.BUCKET}
                    quantity={after.bucketDays}
                    showQuantity
                    className={bucketsDayChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowPlus && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.PLUS}
                    quantity={after.plusDays}
                    showQuantity
                    className={plusDaysChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowAccorded && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.ACCORDED}
                    quantity={after.accordedDays}
                    showQuantity
                    className={accordedDaysChanged ? "" : "opacity-60"}
                  />
                )}
                {shouldShowAdditional && (
                  <VacationDayVariantChip
                    variant={VACATION_DAYS_VARIANTS.LONG}
                    dayType={VACATION_DAY_TYPES.EXTRA}
                    quantity={after.additionalDays}
                    showQuantity
                    className={additionalDaysChanged ? "" : "opacity-60"}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VacationRequestDifferenceDays
